module.exports = __webpack_public_path__ + "static/img/background.1778636131768.png";